module.exports = __webpack_public_path__ + "img/MS.d0bb886c.svg";